'use strict';
vendorPaymentsController.$inject = [
	'$scope',
	'$rootScope',
	'$q',
	'$interval',
	'dialogHelper',
	'reportHelper',
	'vendorService',
	'VENDOR_STATUS',
	'authService',
	'USER_CLAIMS',
	'BUSY_MESSAGE',
];
angular.module('schoolLinqApp').controller('vendorPaymentsController', vendorPaymentsController);

function vendorPaymentsController(
	$scope,
	$rootScope,
	$q,
	$interval,
	dialogHelper,
	reportHelper,
	vendorService,
	VENDOR_STATUS,
	authService,
	USER_CLAIMS,
	BUSY_MESSAGE
) {
	var viewModel = getViewModel($rootScope.mode || 'fund');
	$scope.vm = viewModel;

	$scope.reportInterval = null;
	$scope.isReportFinished = false;

	$scope.loadingPromiseMain = $q.all([$scope.vm.loadVendors($scope.vm)]);

	function getViewModel(moduleName) {
		var model = {
			module: moduleName,
			message: BUSY_MESSAGE.Loading,
			vendors: [],
			numberOfVendors: 0,
			maxNumberOfVendors: 0,
			pageControl: {},
			currentSelectedStatusId: 1,
			currentSearchText: '',
			filter: {
				dateFrom: moment().toDate(),
				dateTo: moment().toDate(),
				checkFrom: null,
				checkTo: null,
				modifiedVendors: [],
				checkBoxAll: false,
				checkBoxAllWasPreviouslyTrue: false,
				currentSelectedCount: 0,
				excludePRInvoices: false,
				statuses: [
					{ Id: 0, Description: 'All Vendors' },
					{ Id: 1, Description: 'Active Vendors' },
					{ Id: 2, Description: 'Inactive Vendors' },
				],
			},
			vendorPaging: {
				searchText: '',
				statusId: VENDOR_STATUS.Active,
				pageSize: 10,
				startIndex: 0,
				orderBy: 'ShortName',
				orderByDescending: false,
			},
			validationErrors: [],
			errors: null,
			isPayrollAccessible: false,
		};

		function loadVendors(model) {
			return vendorService.getVendorsByPage(model.vendorPaging).then(_.partial(finishLoadingVendors, model));

			function finishLoadingVendors(model, response) {
				model.numberOfVendors = response.data.totalNumberOfVendors;
				if (model.numberOfVendors > model.maxNumberOfVendors) {
					model.maxNumberOfVendors = model.numberOfVendors;
				}
				model.vendors = response.data.vendors;

				if (model.filter.checkBoxAll === true) {
					_.each(model.vendors, function (v) {
						v.Selected = true;
					});
				} else {
					let index = -1;
					_.each(model.vendors, function (vendor) {
						index = _.findIndex(model.filter.modifiedVendors, function (v) {
							return v.Id === vendor.Id;
						});

						if (index !== -1) {
							vendor.Selected = model.filter.modifiedVendors[index].Selected;
						} else if (model.filter.checkBoxAllWasPreviouslyTrue === true) {
							vendor.Selected = true;
						}
					});
				}
				return angular.noop;
			}
		}

		function sortby(model, propertyName) {
			model.vendorPaging.orderByDescending = model.vendorPaging.orderBy === propertyName ? !model.vendorPaging.orderByDescending : false;
			model.vendorPaging.orderBy = propertyName;
		}

		function changePage(model, isStatusChange) {
			if (isStatusChange) {
				(model.numberOfVendors = 0), (model.maxNumberOfVendors = 0), (model.filter.currentSelectedCount = 0);
				model.filter.modifiedVendors = [];
				model.filter.checkBoxAllWasPreviouslyTrue = false;
				model.filter.checkBoxAll = false;
			}

			model.currentSelectedStatusId = model.vendorPaging.statusId;
			model.currentSearchText = model.vendorPaging.searchText;
			model.vendorPaging.startIndex = model.pageControl.startIndex;
			$scope.loadPagePromise = model.loadVendors();
		}

		function toggleSelection(model, vendor) {
			//model.filter.selectedVendors []
			//model.filter.checkBoxAll

			if (!vendor) {
				// CheckAll changed.
				var chkAll = model.filter.checkBoxAll;
				model.filter.checkBoxAllWasPreviouslyTrue = false;

				_.each(model.vendors, function (v) {
					v.Selected = chkAll;
				});

				model.filter.modifiedVendors = [];
				model.filter.currentSelectedCount = 0;

				if (chkAll === true) {
					model.filter.currentSelectedCount = model.getSelectedCount();
				}
			} else {
				// vendor selected changed
				var index = _.findIndex(model.filter.modifiedVendors, function (v) {
					return v.Id === vendor.Id;
				});

				if (index !== -1) {
					// vendor exists...
					model.filter.modifiedVendors[index].Selected = vendor.Selected;
				} else {
					// add as unselected vendor
					model.filter.modifiedVendors.push(vendor);
				}

				if (vendor.Selected === false) {
					if (model.filter.checkBoxAll === true) {
						model.filter.checkBoxAllWasPreviouslyTrue = true;
					}
					model.filter.checkBoxAll = false;
				}

				model.filter.currentSelectedCount = model.getSelectedCount();

				if (model.filter.currentSelectedCount === model.maxNumberOfVendors && model.maxNumberOfVendors > 0) {
					// reset checkBoxAll to true
					model.filter.modifiedVendors = [];
					model.filter.checkBoxAllWasPreviouslyTrue = false;
					model.filter.checkBoxAll = true;
				}
			}
		}

		function getSelectedCount(model) {
			if (model.filter.checkBoxAll === true) {
				return model.maxNumberOfVendors;
			}

			var counts = _.countBy(model.filter.modifiedVendors, function (v) {
				return v.Selected === true ? 'selected' : 'unselected';
			});

			if (model.filter.checkBoxAllWasPreviouslyTrue === true) {
				return model.maxNumberOfVendors - (counts.unselected || 0);
			} else {
				return counts.selected;
			}
		}

		function validateReportParams(model) {
			model.validationErrors = [];
			let isValid = true;

			if (!model.filter.dateFrom) {
				model.validationErrors.push("Please select a 'From' date.");
				isValid = false;
			}

			if (!model.filter.dateTo) {
				model.validationErrors.push("Please select a 'To' date.");
				isValid = false;
			}

			if (isValid === true && moment(model.filter.dateFrom).startOf('day') > moment(model.filter.dateTo).startOf('day')) {
				model.validationErrors.push('Date Range is invalid!');
				isValid = false;
			}

			if ((model.filter.checkFrom || 0) > 0 || (model.filter.checkTo || 0) > 0) {
				let chkFrom = model.filter.checkFrom || 0;
				let chkTo = model.filter.checkTo || 0;

				if (chkFrom > 0 && chkTo === 0) {
					model.filter.checkTo = chkFrom;
					chkTo = chkFrom;
				}
				if (chkFrom > chkTo) {
					model.validationErrors.push("Check # 'To' must be greater or equal than Check # 'From'.");
					isValid = false;
				}
			}

			if (model.filter.checkBoxAll === false) {
				var venIds = _.map(_.where(model.filter.modifiedVendors, { Selected: true }), function (vendor) {
					return vendor.Id;
				});
				if ((venIds === null || venIds.length === 0) && model.filter.checkBoxAllWasPreviouslyTrue === false) {
					model.validationErrors.push('Please select one or more Vendors to continue!');
					isValid = false;
				}
			}

			return isValid;
		}

		function openReport(model) {
			if (!validateReportParams(model)) {
				dialogHelper.openMessageBox('Vendor Payments Report Error!', null, model.validationErrors, 'Warning');
				return false;
			}

			$scope.isReportFinished = false;
			model.message = BUSY_MESSAGE.GeneratingReport;
			$scope.loadingPromiseMain = $scope.reportInterval = $interval(function () {
				if ($scope.isReportFinished) {
					$interval.cancel($scope.reportInterval);
					$scope.isReportFinished = false;
				}
			}, 1000);

			if (!model.filter.dateFrom) {
				model.filter.dateFrom = moment().toDate();
			}
			if (!model.filter.dateTo) {
				model.filter.dateTo = moment().toDate();
			}

			// if select all was checked, vendorIds serves as a denylist
			// otherwise, it's an allowlist
			var vendors = _.where(model.filter.modifiedVendors, {
				Selected: !model.filter.checkBoxAllWasPreviouslyTrue,
			});

			var venIds = _.pluck(vendors, 'Id');
			var param = {
				DateFrom: moment(model.filter.dateFrom).format('l'),
				DateTo: moment(model.filter.dateTo).format('l'),
				CheckFrom: model.filter.checkFrom || 0,
				CheckTo: model.filter.checkTo || 0,
				ExcludePRInvoices: model.filter.excludePRInvoices,
				VendorStatusId: model.vendorPaging.statusId,
				Negated: model.filter.checkBoxAll || model.filter.checkBoxAllWasPreviouslyTrue,
				VendorIds: venIds,
			};

			reportHelper.postReport($scope, '/api/fundreports/vendorpaymentsreport', param, 'VendorPaymentsReport.pdf');
		}

		function exportExcel(model) {
			if (!validateReportParams(model)) {
				$scope.isReportFinished = true;
				dialogHelper.openMessageBox('Vendor Payments Excel Error!', null, model.validationErrors);
				return false;
			}

			$scope.isReportFinished = false;
			model.message = BUSY_MESSAGE.GeneratingExcelFile;
			$scope.loadingPromiseMain = $scope.reportInterval = $interval(function () {
				if ($scope.isReportFinished) {
					$interval.cancel($scope.reportInterval);
					$scope.isReportFinished = false;
				}
			}, 1000);

			if (!model.filter.dateFrom) {
				model.filter.dateFrom = moment().toDate();
			}
			if (!model.filter.dateTo) {
				model.filter.dateTo = moment().toDate();
			}

			// if select all was checked, vendorIds serves as a denylist
			// otherwise, it's an allowlist
			var vendors = _.where(model.filter.modifiedVendors, {
				Selected: !model.filter.checkBoxAllWasPreviouslyTrue,
			});

			var venIds = _.pluck(vendors, 'Id');

			var report = {
				DateFrom: moment(model.filter.dateFrom).format('l'),
				DateTo: moment(model.filter.dateTo).format('l'),
				CheckFrom: model.filter.checkFrom || 0,
				CheckTo: model.filter.checkTo || 0,
				ExcludePRInvoices: model.filter.excludePRInvoices,
				VendorStatusId: model.vendorPaging.statusId,
				GetAllVendors: model.filter.checkBoxAll || model.filter.checkBoxAllWasPreviouslyTrue,
				VendorIds: venIds,
			};

			reportHelper.postExcel($scope, '/api/fundreports/vendorpaymentsexcel', report, 'VendorPayments.xlsx');
		}

		return angular.extend(model, {
			loadVendors: _.partial(loadVendors, model),
			sortby: _.partial(sortby, model),
			changePage: _.partial(changePage, model),
			toggleSelection: _.partial(toggleSelection, model),
			getSelectedCount: _.partial(getSelectedCount, model),
			validateReportParams: _.partial(validateReportParams, model),
			openReport: _.partial(openReport, model),
			exportExcel: _.partial(exportExcel, model),
		});
	}
}
